import { EmptyState } from "../../components";
import { t } from "../../i18n/t";

export interface NotMigratedRow {
  entity: string;
  support: string;
  reason: string | null;
  /**
   * §A8.10/§B5.3 (v3-M-6): the API derives this. `reason` is `null` for every row selected by the count branch,
   * so a panel bound to `reason` would render blanks in exactly the case an accountant most needs to see. The
   * client renders `sentence` verbatim and **never** re-derives it.
   */
  sentence: string;
}

/**
 * §B5.3. "Not migrated, and why" — the single most important thing an accountant reads before signing. It is a
 * plain `<section>` with a list: never a `<details>`, never collapsed, never behind a tab. It is rendered here and
 * repeated inside the sign-off dialog (§B5.4 item 2).
 */
export function NotMigrated({ rows }: { rows: readonly NotMigratedRow[] }): JSX.Element {
  return (
    <section data-testid="not-migrated" aria-label={t("dryrun.not_migrated")}>
      <h2>{t("dryrun.not_migrated")}</h2>
      {rows.length === 0 ? (
        <EmptyState title={t("dryrun.not_migrated_empty")} />
      ) : (
        <ul>
          {rows.map((row) => (
            <li key={row.entity} data-testid={`not-migrated-${row.entity}`}>
              {row.sentence}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
